import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { CartService } from 'src/app/services/cart.services';
import { WishlistService } from 'src/app/services/wishlist.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

  constructor(private authService: AuthServiceService , private router:Router, private cartService: CartService ,private wishlist : WishlistService,){
  }
  ngOnInit(): void {
     this.cartService.cart$.subscribe(cart => {
      this.cartItems = cart;
      this.cartCount = cart.reduce((total, item) => total + item.quantity, 0);
    });
      this.wishlist.wishlist$.subscribe(wishlist => {
      this.wishlistCount = this.wishlist.getWishlistCount();
    });
    throw new Error('Method not implemented.');
  }
  passwordMismatch: boolean = false;
  confirmPassword: string = ''; // Variable séparée pour la confirmation du mot de passe

  showPassword: boolean = false;
  showConfirmPassword: boolean = false;
cartItems: any[] = [];
 wishlistCount: number = 0;
  cartCount: number = 0;
  user = {
    email: '',

    nom: '',
    prenom:'',
    telephone:'',
    source:'""',
    date_naissance:'',
    password:'',
    confirmPassword: ''
  };
  errorMessage: string | null = null;


  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmPasswordVisibility(): void {
    this.showConfirmPassword = !this.showConfirmPassword;
  }
   goToAccount(event: Event): void {
    event.preventDefault(); // évite le rechargement

    if (this.authService.getClientId() !== null) {
      this.router.navigate(['/account']);
    } else {
      this.router.navigate(['/login']);
    }
  }
  registerUser(): void {
    console.log("jihen")
    if (this.user.password !== this.confirmPassword) {
      this.passwordMismatch = true;
      return;
    }

    this.passwordMismatch = false;

    // Envoyer seulement les données nécessaires au backend (sans confirmPassword)
    this.authService.register(this.user).subscribe(
      response => {
        console.log('User registered successfully:', response);

        this.router.navigate(['/login']);
      },
      error => {
        console.error('Échec de l\'inscription:', error);
      }
    );
  }

  goToLogin() {
    this.router.navigate(['/login']);
  }
}
